const skeletonWidths = [50, 60, 25, 30, 20, 80, 20];

export const getSkeletonPercentageWidthByIndex = (index: number): string =>
    `${skeletonWidths[index % skeletonWidths.length]}%`;
